<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <i class="icon-list"></i>
                <strong>N-Boxes</strong>
            </b-card-header>
            <b-card-body>
                <div class="d-flex justify-content-end mb-4">
                    <b-button
                        id="btn-nbox-admin-reports"
                        class="mr-2"
                        variant="outline-primary"
                        @click="$router.push('/v2/n-box/report')"
                    >
                        {{ $t('reports.reports') }}
                    </b-button>
                    <b-button id="btn-nbox-admin-new" variant="primary" @click="$router.push('/v2/n-box/new')">
                        {{ $t('form.button.new') }}
                    </b-button>
                </div>
                <b-table
                    hover
                    striped
                    bordered
                    small
                    :items="items"
                    :fields="fields"
                    :busy="isLoading"
                    :show-empty="true"
                    :empty-text="$t('nBox.emptyTable')"
                >
                    <template #thead-top>
                        <tr>
                            <th colspan="1" class="text-center align-middle">NBox</th>
                            <th colspan="3" class="text-center align-middle">
                                {{ $t('permissions.permissions') }}
                            </th>
                            <th colspan="4" class="text-center align-middle">
                                {{ $t('people.actions') }}
                            </th>
                        </tr>
                    </template>
                    <template #cell(userPermissions)="{ item }">
                        <b-form-checkbox
                            class="checkbox-nbox-user-show-quadrant"
                            inline
                            switch
                            v-model="item.show_quadrant_to_user"
                            @change="onUpdateProperty(item.id, $event, 'show_quadrant_to_user')"
                            >{{ $t('nBox.showQuadrant') }}</b-form-checkbox
                        >
                        <br />
                        <b-form-checkbox
                            class="checkbox-nbox-user-show-x-axis"
                            inline
                            switch
                            v-model="item.show_axis_x_to_user"
                            @change="onUpdateProperty(item.id, $event, 'show_axis_x_to_user')"
                            >{{ $t('nBox.showAxis', { axis: 'x' }) }}</b-form-checkbox
                        >
                        <br />
                        <b-form-checkbox
                            class="checkbox-nbox-user-show-y-axis"
                            inline
                            switch
                            v-model="item.show_axis_y_to_user"
                            @change="onUpdateProperty(item.id, $event, 'show_axis_y_to_user')"
                            >{{ $t('nBox.showAxis', { axis: 'y' }) }}</b-form-checkbox
                        >
                    </template>
                    <template #cell(managerPermissions)="{ item }">
                        <b-form-checkbox
                            class="checkbox-nbox-manager-show-quadrant"
                            inline
                            switch
                            v-model="item.show_quadrant_to_manager"
                            @change="onUpdateProperty(item.id, $event, 'show_quadrant_to_manager')"
                            >{{ $t('nBox.showQuadrant') }}</b-form-checkbox
                        >
                        <br />
                        <b-form-checkbox
                            class="checkbox-nbox-manager-show-x-axis"
                            inline
                            switch
                            v-model="item.show_axis_x_to_manager"
                            @change="onUpdateProperty(item.id, $event, 'show_axis_x_to_manager')"
                            >{{ $t('nBox.showAxis', { axis: 'x' }) }}</b-form-checkbox
                        >
                        <br />
                        <b-form-checkbox
                            class="checkbox-nbox-manager-show-y-axis"
                            inline
                            switch
                            v-model="item.show_axis_y_to_manager"
                            @change="onUpdateProperty(item.id, $event, 'show_axis_y_to_manager')"
                            >{{ $t('nBox.showAxis', { axis: 'y' }) }}</b-form-checkbox
                        >
                    </template>
                    <template #cell(committeePermissions)="{ item }">
                        <b-form-checkbox
                            class="checkbox-nbox-committe-show-quadrant"
                            inline
                            switch
                            v-model="item.show_quadrant_to_committee"
                            @change="onUpdateProperty(item.id, $event, 'show_quadrant_to_committee')"
                            >{{ $t('nBox.showQuadrant') }}</b-form-checkbox
                        >
                        <br />
                        <b-form-checkbox
                            class="checkbox-nbox-committee-show-x-axis"
                            inline
                            switch
                            v-model="item.show_axis_x_to_committee"
                            @change="onUpdateProperty(item.id, $event, 'show_axis_x_to_committee')"
                            >{{ $t('nBox.showAxis', { axis: 'x' }) }}</b-form-checkbox
                        >
                        <br />
                        <b-form-checkbox
                            class="checkbox-nbox-committee-show-y-axis"
                            inline
                            switch
                            v-model="item.show_axis_y_to_committee"
                            @change="onUpdateProperty(item.id, $event, 'show_axis_y_to_committee')"
                            >{{ $t('nBox.showAxis', { axis: 'y' }) }}</b-form-checkbox
                        >
                    </template>
                    <template #cell(activate)="{ item }">
                        <b-form-checkbox
                            class="checkbox-nbox-activate"
                            switch
                            v-model="item.is_active"
                            @change="onUpdateProperty(item.id, $event, 'is_active')"
                        />
                    </template>
                    <template #cell(edit)="{ item }">
                        <b-link
                            id="btn-nbox-edit"
                            :title="$t('form.button.edit')"
                            @click="$router.push(`/v2/n-box/edit/${item.id}`)"
                        >
                            <i class="fa fa-pencil fa-lg text-primary"></i>
                        </b-link>
                    </template>
                    <template #cell(download)="{ item }">
                        <b-link
                            id="btn-nbox-download"
                            :title="$t('form.button.export')"
                            @click="onClickDownloadNBox(item.id, item.title)"
                            v-if="!isDownloadingNbox(item.id)"
                        >
                            <i class="fa fa-download fa-lg text-primary"></i>
                        </b-link>
                        <i v-else class="fas fa-spinner fa-spin text-primary"></i>
                    </template>
                    <template #cell(delete)="{ item }">
                        <b-link
                            id="btn-nbox-delete"
                            :title="$t('form.button.delete')"
                            @click="onDeleteHandler(item.id)"
                        >
                            <i class="fa fa-trash fa-lg text-danger"></i>
                        </b-link>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import { getNBoxes, updateNBox, deleteNBox, downloadNBox } from './api'
import { deleteConfirmationWithLoading } from '@/config/sweet-alert'
import notification, { success, danger } from '@/lib/notification'
import { forceFileDownload } from '@/lib/utils'

notification.init()

export default {
    name: 'List',
    data() {
        return {
            isLoading: true,
            items: [],
            downloadingNboxes: [],
            fields: [
                {
                    key: 'title',
                    label: i18n.t('form.label.title'),
                    thClass: 'text-center',
                },
                {
                    key: 'userPermissions',
                    label: i18n.t('roles.user'),
                    tdClass: 'align-middle permissions',
                },
                {
                    key: 'managerPermissions',
                    label: i18n.t('roles.manager'),
                    tdClass: 'align-middle permissions',
                },
                {
                    key: 'committeePermissions',
                    label: i18n.t('nBox.committee'),
                    tdClass: 'align-middle permissions',
                },
                {
                    key: 'activate',
                    label: i18n.t('nBox.activate'),
                    thClass: 'text-center',
                    tdClass: 'text-center align-middle actions',
                },
                {
                    key: 'edit',
                    label: i18n.t('form.button.edit'),
                    thClass: 'text-center',
                    tdClass: 'text-center align-middle actions',
                },
                {
                    key: 'download',
                    label: i18n.t('form.button.export'),
                    thClass: 'text-center',
                    tdClass: 'text-center align-middle actions',
                },
                {
                    key: 'delete',
                    label: i18n.t('form.button.delete'),
                    thClass: 'text-center',
                    tdClass: 'text-center align-middle actions',
                },
            ],
        }
    },
    mounted() {
        this.getNBoxes()
    },
    methods: {
        onUpdateProperty(id, value, field) {
            const promise = updateNBox(id, { [field]: value })
            this.setPromiseDefaultHandlers(promise)
        },
        onDeleteHandler(nBoxID) {
            Swal({
                ...deleteConfirmationWithLoading,
                preConfirm: () => {
                    return deleteNBox(nBoxID)
                },
            })
                .then((resp) => {
                    const { value } = resp
                    if (value) {
                        this.notificationNBoxDeletedSuccessfully()
                        this.getNBoxes()
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
        },
        onClickDownloadNBox(nBoxID, title) {
            this.downloadingNboxes.push(nBoxID)
            downloadNBox(nBoxID).then((response) => {
                forceFileDownload(response, `${title}.xlsx`)
                this.downloadingNboxes = this.downloadingNboxes.filter((id) => id !== nBoxID)
            })
        },
        isDownloadingNbox(nBoxId) {
            return this.downloadingNboxes.includes(nBoxId)
        },
        setPromiseDefaultHandlers(promise) {
            promise
                .then(() => {
                    this.notificationNBoxUpdatedSuccessfully()
                    this.getNBoxes()
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
        },
        notificationNBoxUpdatedSuccessfully() {
            success(
                i18n.t('notification.editedSuccessfully', {
                    item: 'N-Box',
                })
            )
        },
        notificationNBoxDeletedSuccessfully() {
            success(
                i18n.t('notification.deletedSuccessfully', {
                    item: 'N-Box',
                })
            )
        },
        notificationError() {
            danger()
        },
        getNBoxes() {
            return getNBoxes()
                .then((data) => {
                    this.items = data
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>

<style>
.permissions {
    width: 15%;
}
.actions {
    width: 10%;
}
</style>
